// Components==============
import React from 'react';
import { motion } from 'framer-motion';
import './index.module.scss';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
// =========================

export default function NewsCard({ image, title, created_at, id }) {
    const openInformationModal = useOpenUrlModal(`nieuws/nieuws-popup/${id}`);

    return (
        <>
            <motion.div
                onClick={() => openInformationModal()}
                whileHover={{ scale: 1.025 }}
                whileTap={{ scale: 0.975 }}
                styleName="news"
            >
                <img src={image} alt="news" />
                <p styleName="description">{title}</p>
                <span styleName="date">{created_at}</span>
            </motion.div>
        </>
    );
}
